function addAuthorModal(authorBtn) {
    const modal = document.querySelector('.js-author-modal')
    const closeBtn = document.querySelectorAll('.js-author-modal__close')
    const html = document.querySelector('html')

    // early return if there is no author modal
    if (!modal) {
        return
    }

    function moveModal() {
        modal.parentNode.removeChild(modal)
        document.body.appendChild(modal)
    }

    moveModal()

    authorBtn.addEventListener('click', () => {
        console.log('hi')
        modal.style.display = 'block'
        html.classList.add('js-overflow-hidden')
    })

    closeBtn.forEach((btn) => {
        btn.addEventListener('click', () => {
            modal.style.display = 'none'
            html.classList.remove('js-overflow-hidden')
        })
    })

    window.addEventListener('click', (event) => {
        if (event.target === modal) {
            modal.style.display = 'none'
            html.classList.remove('js-overflow-hidden')
        }
    })
}

export function initAuthorModal() {
    const authorBtns = document.querySelectorAll('.js-article-author__author-btn')
    authorBtns.forEach((authorBtn) => {
        addAuthorModal(authorBtn)
    })
}
